import {
    avatar14,
    img15,
    img16,
    img17,
    img18,
  } from "../../_components/Imagepath";
  
  export default {
    QuotationData: [
        {
          "id": 1,
          "transactionId": "AA1100123",
          "transactionDate": "01 Aug 2023, 04:35 PM",
         
            "image": avatar14,
            "name": "Orn LLC",
            "email": "orn@example.com",
        
          "amount": "$199.99",
          "dueDate": "20 Aug 2023"
        },
        {
          "id": 2,
          "transactionId": "AA1100123",
          "transactionDate": "05 Aug 2023, 07:00 PM",
         
            "image": img15,
            "name": "Accent Technology",
            "email": "accent@example.com",
        
          "amount": "$99.99",
          "dueDate": "23 Aug 2023"
        },
        {
          "id": 3,
          "transactionId": "AA1100123",
          "transactionDate": "13 Aug 2023, 06:35 PM",
          
            "image": img16,
            "name": "Express Advertising",
            "email": "express@example.com",
       
          "amount": "$300.00",
          "dueDate": "24 Aug 2023"
        },
        {
          "id": 4,
          "transactionId": "AA1100123",
          "transactionDate": "15 Aug 2023, 03:30 PM",
         
            "image": img17,
            "name": "Lexicon Technologies",
            "email": "lexicon@example.com",
        
          "amount": "$690.00",
          "dueDate": "25 Aug 2023"
        },
        {
          "id": 5,
          "transactionId": "AA1100123",
          "transactionDate": "16 Aug 2023, 05:15 PM",
        
            "image": img18,
            "name": "Sumo Soft Limited",
            "email": "sumo@example.com",
        
          "amount": "$99.99",
          "dueDate": "30 Aug 2023"
        }
      ]
  };
  